// extracted by mini-css-extract-plugin
export default {"wrapper":"confirm_wrapper__QwRGk","wrapItem":"confirm_wrapItem__PHaQS","img":"confirm_img__WOVnX","products":"confirm_products__7goXr"};